export type TrainerTier = "A" | "B" | "C" | "D" | "E";

export interface TrainerInfo {
  id: string;
  name: string;
  firmware?: string;
  tier: TrainerTier;
}

export interface PowerSample {
  /** Epoch milliseconds when the notification was received. */
  t: number;
  watts: number;
  cadence: number;
  /** Instantaneous speed in km/h when the trainer reports it. */
  speed?: number;
}

export interface TrainerDevice {
  connect(): Promise<TrainerInfo>;
  disconnect(): Promise<void>;
  onPower(callback: (sample: PowerSample) => void): () => void;
  setGrade(gradePct: number): Promise<void>;
  setTargetPower(watts: number): Promise<void>;
  /** Fixed resistance level, 0..100 (percent of the trainer's range). */
  setResistance(level: number): Promise<void>;
  calibrate(): Promise<void>;
  getInfo(): TrainerInfo | null;
}

export interface TrainerDifficultySettings {
  /** 0..1, default 0.5. */
  difficulty: number;
}

export const DEFAULT_DIFFICULTY = 0.5;
export const VICTORY_MAX_GRADE_PCT = 16;
export const VICTORY_MIN_GRADE_PCT = -10;
